import numbro from 'numbro';
import itIT from 'numbro/languages/it-IT';
import enGB from 'numbro/languages/en-GB';

numbro.registerLanguage(itIT as any);
numbro.registerLanguage(enGB as any);

numbro.setDefaults({
  thousandSeparated: true,
  mantissa: 2,
});

export function numbroSetLanguage(language: string) {
  numbro.setLanguage(language);
}

export function toFixedString(
  value: number,
  lang?: string,
  digits: number = 2
) {
  return Number(value).toLocaleString(lang, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function valueToPercent(
  value: number,
  min: number,
  max: number
): number {
  if (value === min) return 0;
  return ((value - min) * 100) / (max - min);
}

export function areNumbersClose(target: number, value: number) {
  return Math.abs(value - target) < 0.000000001;
}

export function abbreviate(value: number | string, lang?: string) {
  /*
    K for Thousands
    MM or M for Millions
    B, Bn, Bil for Billions
    T or Tn for Trillion
  */
  const number = typeof value === 'string' ? parseFloat(value) : value;
  let newNumber = number;
  let suffix = '';
  let decimals = 0;

  if (number >= 100000000) {
    newNumber = number / 1000000000;
    suffix = 'B';
    decimals = 1;
  } else if (number >= 1000000) {
    newNumber = number / 1000000;
    suffix = 'M';
    decimals = 1;
  } else if (number >= 1000) {
    newNumber = number / 1000;
    suffix = 'K';
    decimals = 0;
  }

  return toFixedString(newNumber, lang, decimals) + suffix;
}

export function romanize(num: number) {
  const lookup: Record<string, number> = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };
  let roman = '';

  Object.keys(lookup).forEach((key) => {
    while (num >= lookup[key]) {
      roman += key;
      num -= lookup[key];
    }
  });
  return roman;
}
